import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { CollectiveAgreementCategoryDto } from "@/core/features/collective-agreement-categories/collective-agreement-category.dto";
import { CreateCollectiveAgreementCategoryDto } from "@/core/features/collective-agreement-categories/create-collective-agreement-category.dto";
import { UpdateCollectiveAgreementCategoryDto } from "@/core/features/collective-agreement-categories/update-collective-agreement-category.dto";
import { getOptionLoader } from "@/core/common/presenters/optionLoader";
import { merge } from "lodash";
import { HttpRequest } from "@/core/common/http/http-request";
import { bufferToBlob } from "@/utils/fileUtils";
import { formatAppDate } from "@/utils/dates/dateFormats";

export class CollectiveAgreementCategoriesResource extends ResourceBaseService<
  CollectiveAgreementCategoryDto,
  CreateCollectiveAgreementCategoryDto,
  UpdateCollectiveAgreementCategoryDto
> {
  protected EntityDto = CollectiveAgreementCategoryDto;
  protected CreateEntityDto = CreateCollectiveAgreementCategoryDto;
  protected UpdateEntityDto = UpdateCollectiveAgreementCategoryDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/collective-agreement-categories");
  }

  async optionLoader(inputValue: string, _includeArchived: boolean, customRequest?: IRequest): Promise<OptionType[]> {
    return getOptionLoader(
      inputValue,
      ["id", "name"],
      [{ field: "name", order: "ASC" }],
      (request) => {
        const req = customRequest ? merge(request, customRequest) : request;
        return this.findAll(req);
      },
      ["name"],
      {},
      undefined
    );
  }

  async importCollectiveAgreementCategories(
    file: File,
    collectiveAgreementId: string
  ): Promise<{ status: "queued"; jobId: string }> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("collectiveAgreementId", collectiveAgreementId);

    return this.apiHttpClient.request<FormData, { status: "queued"; jobId: string }>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/import",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }

  async downloadImportExportFile(collectiveAgreementId: string): Promise<void> {
    const data = await this.apiHttpClient.request<null, string>(
      HttpRequest.create({
        url: this.resourceUrl + "/import/export",
        method: "GET",
        auth: true,
        query: `collectiveAgreementId=${encodeURIComponent(collectiveAgreementId)}`,
      })
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      bufferToBlob(data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    );
    link.download = `GPARN-categorias-convenio-import-${formatAppDate(new Date(), false)}.xlsx`;
    link.click();
  }
}
